import { render, staticRenderFns } from "./OnboardingSuccess.vue?vue&type=template&id=38b6347a&"
import script from "./OnboardingSuccess.ts?vue&type=script&lang=ts&"
export * from "./OnboardingSuccess.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports